// src/schemas/userSchema.js
import * as yup from "yup";

export const userSchema = yup.object({
  full_name: yup.string().required("Full name is required"),
  email: yup.string().email("Must be a valid email").required(),
  country_code : yup.string().required('Country code is required'),
  phone: yup
    .string()
    .matches(/^\+?[0-9]{7,15}$/, "Must be a valid phone number")
    .required(),
  created_at: yup.date().required("Join date is required"),
  subscriptionStatus: yup.string().oneOf(["Free", "Premium"]).required(),
  is_active: yup
    .boolean()
    .oneOf([true, false], "Status must be true or false")
    .required(),

  // switch to the function form of .when()
  password: yup.string().when("$mode", (mode, schema) => {
    if (mode === "create") {
      return schema
        .min(6, "At least 6 characters")
        .required("Password is required for new users");
    }
    // edit mode: keep whatever value exists (or empty)
    return schema.notRequired();
  }),
});
